import { MarketRoot } from 'components/market/ui';

export const PageTemplate: React.FC<
  React.PropsWithChildren<{ showBack?: boolean }>
> = ({ children }) => {
  return <MarketRoot>{children}</MarketRoot>;
};
